export const MENU_VIEWS = {
    HOME: 'home',
    ABOUT: 'about',
    CONTACT: 'contact',
    TRAINING: 'training',
    ARTICLES: 'articles',
};

export const defaultState = {
    data: {
        homeContent: '',
        about: '',
    },
    menuView: MENU_VIEWS.HOME,
    toast: {
        content: '',
        open: false,
        toastSeverity: 'success',
    },
};
